/* ============================================================
 * TF · Navegación — comportamiento del header + mega menú.
 * Reproducción fiel del prototipo aprobado (handoff §8/§9).
 * NO reinterpretar. Timings del prototipo:
 *   abrir mega: clip-path 460ms · scrim 420ms
 *   swap de mundo en el mismo panel: 190–210ms, la carcasa no se mueve
 *   cerrar: puntero sale del nav → 220ms de gracia · Esc · entrar a un mundo
 *   subrayado de nav: 2px scaleX desde la izquierda 320ms
 * Un solo rAF compartido para magnetismo. transform/opacity/clip-path only.
 * ============================================================ */
(function () {
  "use strict";
  if (window.__tfNav) return; window.__tfNav = true;

  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fine = matchMedia("(pointer: fine)").matches;
  var GRACE = 220;

  function ready(fn){ document.readyState !== "loading" ? fn() : document.addEventListener("DOMContentLoaded", fn); }

  ready(function () {
    var header = document.querySelector("[data-tf-header]");
    if (!header) return;
    var panel = header.querySelector("[data-tf-mega]");
    var scrim = header.querySelector("[data-tf-mega-scrim]");
    var swap = header.querySelector("[data-tf-mega-swap]");
    var triggers = header.querySelectorAll("[data-tf-world-trigger]");
    var closeTimer = null;
    var openWorld = null;

    function setUnderline(world) {
      triggers.forEach(function (t) {
        var on = t.getAttribute("data-tf-world-trigger") === world;
        t.setAttribute("aria-expanded", on ? "true" : "false");
        var line = t.querySelector("[data-tf-nav-line]");
        if (line) line.style.transform = "scaleX(" + (on ? 1 : (t.hasAttribute("data-tf-current") ? 1 : 0)) + ")";
      });
    }

    function showWorld(world) {
      header.querySelectorAll("[data-tf-mega-world]").forEach(function (w) {
        w.hidden = w.getAttribute("data-tf-mega-world") !== world;
      });
    }

    function open(world) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      var swapping = openWorld && openWorld !== world;
      openWorld = world;
      header.setAttribute("data-tf-open", "true");
      if (panel) panel.hidden = false;
      if (scrim) scrim.hidden = false;
      showWorld(world);
      setUnderline(world);
      // swap de contenido en el mismo panel (la carcasa no se mueve)
      if (swapping && swap && !reduce) {
        swap.style.transition = "none";
        swap.style.opacity = "0";
        swap.style.transform = "translate3d(22px,0,0)";
        requestAnimationFrame(function () {
          swap.style.transition = "opacity 190ms linear, transform 190ms cubic-bezier(.22,1,.36,1)";
          swap.style.opacity = "1";
          swap.style.transform = "translate3d(0,0,0)";
        });
      }
      requestAnimationFrame(function () { header.classList.add("is-open"); });
    }

    function close() {
      header.classList.remove("is-open");
      header.removeAttribute("data-tf-open");
      openWorld = null;
      setUnderline(null);
      var done = function () {
        if (header.classList.contains("is-open")) return;
        if (panel) panel.hidden = true;
        if (scrim) scrim.hidden = true;
      };
      if (reduce) done(); else setTimeout(done, 470);
    }

    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(close, GRACE);
    }

    triggers.forEach(function (t) {
      var world = t.getAttribute("data-tf-world-trigger");
      // focus SIEMPRE abre (paridad de teclado, no-neg #9); hover solo en puntero fino
      t.addEventListener("focus", function () { open(world); });
      if (fine) t.addEventListener("mouseenter", function () { open(world); });
      // click/tap entra al mundo (deja navegar por el href)
    });

    header.addEventListener("mouseleave", scheduleClose);
    if (panel) panel.addEventListener("mouseenter", function () { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } });
    if (panel) panel.addEventListener("mouseleave", scheduleClose);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && header.getAttribute("data-tf-open") === "true") { close(); }
    });

    /* Preview col 03: hover en un item actualiza la vista previa desde data-* */
    header.querySelectorAll("[data-tf-preview-src]").forEach(function (item) {
      function apply() {
        var world = item.getAttribute("data-tf-preview-world") || openWorld;
        var view = header.querySelector('[data-tf-preview="' + world + '"]');
        if (!view) return;
        item.getAttributeNames().forEach(function (n) {
          if (n.indexOf("data-pv-") === 0) {
            var key = n.slice(8);
            var el = view.querySelector('[data-pv-slot="' + key + '"]');
            if (el) el.textContent = item.getAttribute(n);
          }
        });
      }
      item.addEventListener("mouseenter", apply);
      item.addEventListener("focus", apply);
    });

    /* ── Navegación móvil ── */
    var mnav = document.querySelector("[data-tf-mnav]");
    if (mnav) {
      var mLast = null;
      function mSetWorld(world) {
        mnav.setAttribute("data-tf-mnav-active", world);
        mnav.querySelectorAll("[data-tf-mnav-world]").forEach(function (w) { w.hidden = w.getAttribute("data-tf-mnav-world") !== world; });
        mnav.querySelectorAll("[data-tf-mnav-tab]").forEach(function (t) { t.setAttribute("aria-selected", t.getAttribute("data-tf-mnav-tab") === world ? "true" : "false"); });
        var enter = mnav.querySelector("[data-tf-mnav-enter]");
        if (enter) { enter.setAttribute("data-tf-world", world); enter.textContent = world === "sport" ? "Entrar a Sportswear" : "Entrar a Streetwear"; }
        var swap = mnav.querySelector("[data-tf-mnav-swap]");
        if (swap && !reduce) {
          swap.style.transition = "none"; swap.style.opacity = "0"; swap.style.transform = "translate3d(22px,0,0)";
          requestAnimationFrame(function () { swap.style.transition = "opacity 190ms linear, transform 190ms cubic-bezier(.22,1,.36,1)"; swap.style.opacity = "1"; swap.style.transform = "translate3d(0,0,0)"; });
        }
      }
      function mOpen() {
        mLast = document.activeElement;
        mnav.hidden = false;
        requestAnimationFrame(function () { mnav.classList.add("is-open"); });
        document.body.classList.add("tf-lock");
        var c = mnav.querySelector("[data-tf-mnav-close]"); if (c) setTimeout(function () { c.focus(); }, 60);
      }
      function mClose() {
        mnav.classList.remove("is-open");
        document.body.classList.remove("tf-lock");
        var done = function () { if (!mnav.classList.contains("is-open")) mnav.hidden = true; };
        if (reduce) done(); else setTimeout(done, 530);
        if (mLast && mLast.focus) mLast.focus();
      }
      mSetWorld("street");
      document.querySelectorAll("[data-tf-mnav-open]").forEach(function (b) { b.addEventListener("click", mOpen); });
      mnav.querySelectorAll("[data-tf-mnav-close]").forEach(function (b) { b.addEventListener("click", mClose); });
      mnav.querySelectorAll("[data-tf-mnav-tab]").forEach(function (t) { t.addEventListener("click", function () { mSetWorld(t.getAttribute("data-tf-mnav-tab")); }); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && mnav.classList.contains("is-open")) mClose(); });
    }

    /* Magnetismo compartido (un solo rAF, campo de 120px) — botones data-tf-mag.
       El botón se imanta cuando el cursor entra a 120px de su borde: se traslada
       ≤pull px hacia el cursor, escalado por proximidad. El ease de 300ms lo da la
       transición CSS `transform` del botón (transform-only, sin animación perpetua). */
    if (fine && !reduce) {
      var mags = [].slice.call(document.querySelectorAll("[data-tf-mag]"));
      if (mags.length) {
        var FIELD = 120, cx = -9999, cy = -9999, scheduled = false;
        var apply = function () {
          scheduled = false;
          for (var i = 0; i < mags.length; i++) {
            var el = mags[i], r = el.getBoundingClientRect();
            if (r.width === 0) { continue; }
            var pull = parseFloat(el.getAttribute("data-tf-mag")) || 4;
            var nx = Math.max(r.left, Math.min(cx, r.right));
            var ny = Math.max(r.top, Math.min(cy, r.bottom));
            var dx = cx - nx, dy = cy - ny, dist = Math.sqrt(dx * dx + dy * dy);
            if (dist < FIELD) {
              var k = 1 - dist / FIELD;                       // 0..1 por proximidad
              var ccx = r.left + r.width / 2, ccy = r.top + r.height / 2;
              var vx = cx - ccx, vy = cy - ccy, vlen = Math.sqrt(vx * vx + vy * vy) || 1;
              el.style.transform = "translate(" + (vx / vlen * pull * k).toFixed(2) + "px," + (vy / vlen * pull * k).toFixed(2) + "px)";
            } else if (el.style.transform) {
              el.style.transform = "";                         // CSS lo devuelve en 300ms
            }
          }
        };
        document.addEventListener("pointermove", function (e) {
          cx = e.clientX; cy = e.clientY;
          if (!scheduled) { scheduled = true; requestAnimationFrame(apply); }
        }, { passive: true });
        window.addEventListener("blur", function () { mags.forEach(function (el) { el.style.transform = ""; }); });
      }
    }
  });
})();
